import type { RouteObject } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useLocale } from "@seller/app/locale";
import { QuickSetupPage } from "./pages/QuickSetupPage";

function QuickSetupRoute() {
  const locale = useLocale();
  const { storeSlug = "" } = useParams();

  return <QuickSetupPage locale={locale} storeSlug={storeSlug} />;
}

export const onboardingRoutes: RouteObject[] = [
  {
    path: "quick-setup",
    element: <QuickSetupRoute />,
  },
];
